export const enrollmentForm = {
  title: "Solicitação de Pré-Matrícula",
  subtitle: "Preencha este formulário e entraremos em contato para iniciar o processo de admissão",
  
  contactInfo: "Informações de Contato",
  parentName: "Nome completo do pai/mãe/tutor",
  email: "Email",
  phone: "Telefone",
  
  childrenInfo: "Informações das Crianças",
  child: "Criança",
  addChild: "Adicionar outra criança",
  childName: "Nome da criança",
  birthDate: "Data de nascimento",
  currentSchool: "Escola atual",
  currentSchoolPlaceholder: "Opcional",
  desiredLevel: "Nível desejado",
  
  levels: {
    infantil: "Infantil (3-5 anos)",
    primaryC1: "Primária C1 (6-8 anos)",
    primaryC2: "Primária C2 (9-11 anos)"
  },
  
  preferences: "Preferências",
  preferredStartDate: "Data de início preferida",
  immediate: "Imediato",
  howDidYouHear: "Como nos conheceu?",
  
  sources: {
    web: "Site",
    recommendation: "Recomendação",
    socialMedia: "Redes sociais",
    openHouse: "Jornada de portas abertas",
    other: "Outro"
  },
  
  servicesInterest: "Serviços de Interesse",
  services: {
    transport: "Transporte escolar",
    earlyBirds: "Madrugadores (8:00-8:45h)",
    lunch: "Almoço"
  },
  
  comments: "Comentários ou perguntas",
  commentsPlaceholder: "Conte-nos qualquer informação adicional que considere relevante...",
  
  privacyPolicy: "Li a informação sobre proteção de dados",
  
  submit: "Enviar Solicitação",
  submitting: "Enviando...",
  
  success: "Solicitação enviada com sucesso! Entraremos em contato em breve.",
  error: "Erro ao enviar solicitação. Por favor, tente novamente ou entre em contato diretamente conosco.",

  stepper: {
    steps: {
      contact: "Seus dados",
      children: "Seus filhos",
      preferences: "Preferências",
      services: "Serviços",
      review: "Revisão",
    },
    next: "Continuar",
    previous: "Anterior",
    stepOf: "Passo {current} de {total}",
  },
};